let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hQCl0")).then(() => parcelRequire('jTATF'));